function isStackSegmentation(operationData) {
    return (operationData.imageIdReferenceMap !==
        undefined);
}
function isVolumeSegmentation(operationData) {
    return (operationData.volumeId !== undefined);
}
export { isStackSegmentation, isVolumeSegmentation };
//# sourceMappingURL=stackVolumeCheck.js.map